module.exports = __webpack_public_path__ + "static/media/3-6.8a2ec9c6.mp3";